import { Location } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { forkJoin, Subscription } from 'rxjs';
import { DocumentTypeEnterprise } from "src/app/core/class/DocumentTypeEnterprise";
import { Message } from "src/app/core/class/message";
import { LotType } from "src/app/core/constants/lot-type";
import { AutoEnterpriseService } from "src/app/core/services/auto-enterprise.service";
import { CommonService } from "src/app/core/services/common.service";
import { ContractLotService } from "src/app/core/services/contract-lot.service";
import { CreateContractService } from "src/app/core/services/create-contract.service";
import { DocumentTemplateService } from "src/app/core/services/document-template.service";
import { DocumentTypeService } from "src/app/core/services/document-type.service";
import { DocumentService } from 'src/app/core/services/document.service';
import { NotificationService } from "src/app/core/services/notification.service";
import { ProcessingService } from 'src/app/core/services/processing.service';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { WarningSmsContractService } from "src/app/core/services/warning-sms-contract.service";
import { ContractLot } from "../../../../../../shared/models/contract-lot";
import { DialogPreviewPdfComponent } from '../../document-management/dialog-preview-pdf/dialog-preview-pdf.component';

@Component({
  selector: "app-contract-lot-standardized",
  templateUrl: "./contract-lot-standardized.component.html",
  styleUrls: ["./contract-lot-standardized.component.scss"],
})
export class ContractLotStandardizedComponent implements OnInit, OnDestroy {

  isShowStep = false;
  current = 0;
  fileBase64: string = "";
  documentTypeEnterprise: DocumentTypeEnterprise;
  serviceType: any;
  public templateId: number;
  createSide: any = null;
  dataFootNote: any = null;

  currentTab: number = 0;
  id: string = null;
  contractLot: ContractLot = null;
  dynamicColumns: any = []
  tableData: any = []
  lotGroupColumns: { name: string; span: number }[] = [];
  lotGroupRowColumns: string[] = [];
  private EventWarningContractSubscription: Subscription;
  viewMode: 'create' | 'view' = 'create';

  templateFile: any = null;
  name: string = null;
  processing: any = null;

  errorFile: boolean = false;

  subcription: Subscription = new Subscription();

  userSign: string = null;

  checked = true;
  checkFirtClick = true;
  public cecaEnable: boolean;
  isNotAttestedUser: boolean = false;

  dataUserSign: any = null;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  isHaveDeleteCreata: boolean = false;
  maxNumberOfCustomerInFlow: number = 1;
  public noteWarning = "";
  isContainCustomerSignature = false;

  filteredPartyOptions: any = []
  timeOutQueryServer: any;
  inputPartyValue: string = ''
  nzCheckLoadingParty2 = false

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toast: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    public contractLotService: ContractLotService,
    public templateFileService: TemplateFileService,
    public processingService: ProcessingService,
    public location: Location,
    private createContractService: CreateContractService,
    public documentService: DocumentService,
    public autoEnterpriseService: AutoEnterpriseService,
    private warningSmsContractService: WarningSmsContractService,
    ) {
    this.checked = true;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnDestroy(): void {
    this.EventWarningContractSubscription.unsubscribe();
  }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';

    if (this.id) {
      this.viewMode = 'view';
      /**
       * Subscibe data queue emit from websocket
       */
        // let count = 0;
      const readRecordTaskSub = this.processingService.recordSocketContractQueue.subscribe(record => {
          try {
            // console.log(`🌈 ~ vcl message websocket này: \n${JSON.stringify(record, null, 4)}`)
            // console.log('💦',JSON.stringify(this.contractLot, null, 4))
            this.contractLot.contractDetails.map(el => {
              if (el.id == record.idEncrypt) {
                el.status = record.status;
                el.errorMessage = record.errorMessage;
                return el;
              } else return el;
            })
          } catch (e) {
            console.log(`🚀`, e)
          }

        })

      const proccesingTaskSub = this.processingService.processingTask.subscribe(ref => {
        const process = ref.find(item => item.id.replace(/\=/g, '') === this.id.replace(/\=/g, '') && item.type === LotType.CONTRACT_MOHA_LOT);
        if (process) {
          // if (this.processing && this.processing.percent !== process.percent) {
          this.contractLotService.getContractLotById(this.id).subscribe(res => {
            if (!res || !res.data) {
              return;
            }
            this.contractLot = res.data;
            this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;
          })
          // }
          this.processing = process;
        } else if (this.processing) {
          this.contractLotService.getContractLotById(this.id).subscribe(res => {
            if (!res || !res.data) {
              return;
            }
            this.contractLot = res.data;
            this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;
          });
          if (this.processing.percent == 100)
            this.processing = null;
        }
      });
      this.subcription.add(proccesingTaskSub);
      this.subcription.add(readRecordTaskSub);
      this.contractLotService.getContractLotById(this.id).subscribe(res => {
        if (!res || !res.data) {
          return;
        }
        this.contractLot = res.data;
        this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;

        this.dataFootNote = this.contractLot.signatures ? this.contractLot.signatures : null;
        if (this.contractLot.enterpriseSign) {
          this.createSide = this.contractLot.enterpriseSign.find(item => item.isCreatedSide && item.isCreatedSideJoin);
          if (this.createSide && this.contractLot.userSign) {
            const userSign = this.contractLot.userSign.find(item => item.role === 1);
            this.userSign = userSign && userSign.name ? userSign.name : null;
          }
        }
        this.documentTypeService.findById(this.contractLot.documentTypeEnterpriseId).subscribe(resDT => {
          if (!res || !res.data) {
            return;
          }
          this.isShowStep = true;
          this.documentTypeEnterprise = resDT.data;
        });
      })
      forkJoin([
        this.documentTypeService.getInfoProperties(null, false),
        this.contractLotService.getPropertiesContractLotById(this.id)
      ]).subscribe((res) => {
        if(!res[0].success){
          this.toast.error(res[0].message)
          return;
        }
        if(!res[1].success){
          this.toast.error(res[1].message)
          return;
        }
        this.dynamicColumns = res[0].data
          .filter(e => e.inputType !== "HEADER")
          .sort((first, second) => Number(first.order || 0) - Number(second.order || 0));
        this.buildGroupColumns(res[0].data);
        this.tableData = this.mapContractReportRows(res[1].data);

        console.log('[LotReport] res[0].data (get-all):', res[0].data);
        console.log('[LotReport] nhóm:', this.lotGroupColumns);
      })
      
    } 
    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (response) => {
        this.isBuyContract1Mb = response.isBuyContract1Mb;
        this.isBuyContract10Mb = response.isBuyContract1Mb;
      }
    );
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  renderNumber(type: 'total' | 'success' | 'error') {
    if (this.contractLot && this.contractLot.contractDetails) {
      switch (type) {
        case 'total':
          return this.contractLot.contractDetails.length;
        case 'error':
          return this.contractLot.contractDetails.filter(item => {
            return item.status === 'ERROR';
          }).length;
        case 'success':
          return this.contractLot.contractDetails.filter(item => {
            return item.status === 'DONE';
          }).length;
      }
    }
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('contract_lot.status.error_lot');
      case 'PROCESSING':
        return this.message.getMessage('contract_lot.status.processing');
      case 'DONE':
        return this.message.getMessage('contract_lot.status.success');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red'};
      case 'PROCESSING':
        return {'color': 'blue'};
      default:
        return {'color': 'green'};
    }
  }

  preview() {
    this.templateFileService.getContentTemplateFileByUrl({
      type: 'TEMPLATE_PDF',
      url: this.templateFile.file.pdfUrl
    }).subscribe(rs => {
      if (!rs) {
        return;
      }
      this.dialog.open(DialogPreviewPdfComponent, {
        width: '80%',
        data: {
          file: rs,
          name: this.name,
        },
      });
    })
  }

  getResultFile() {
    this.contractLotService.getResultFile(this.id).subscribe(res => {
      this.downLoadFile(res, 'application/octet-stream', 'BSTT_HDLD_ketqua.xlsx');
    })
  }

  private mapContractReportRows(rows: any[]): any[] {
    return (rows || []).map(row => {
      const fieldsByKey = new Map<string, any>();
      (row.contractMohaFields || []).forEach(field => {
        fieldsByKey.set(field.key, field);
      });

      const reportFields = this.dynamicColumns.map(column => {
        const field = fieldsByKey.get(column.code);
        return {
          ...column,
          key: column.code,
          value: field ? field.value : null
        };
      });

      return {
        ...row,
        reportFields
      };
    });
  }

  // Gom cột động theo tên cha gần nhất (các section trùng tên gộp chung 1 nhóm),
  // giống bảng lịch sử tiêu chí ở màn chi tiết
  buildGroupColumns(dataStandard: any[]) {
    const fieldByCode = new Map<string, any>();
    (dataStandard || []).forEach(f => {
      if (f.code && !fieldByCode.has(f.code)) fieldByCode.set(f.code, f);
    });

    const groupNameOf = (f: any): string => {
      const parent = f.parentCode ? fieldByCode.get(f.parentCode) : null;
      return parent ? String(parent.name || parent.code || '').trim() : '';
    };

    const groupOrder: string[] = [];
    const buckets = new Map<string, any[]>();
    this.dynamicColumns.forEach((f: any) => {
      const g = groupNameOf(f);
      let bucket = buckets.get(g);
      if (!bucket) {
        bucket = [];
        buckets.set(g, bucket);
        groupOrder.push(g);
      }
      bucket.push(f);
    });
    const orderedColumns: any[] = [];
    groupOrder.forEach(g => orderedColumns.push(...(buckets.get(g) || [])));
    this.dynamicColumns = orderedColumns;

    this.lotGroupColumns = [];
    this.lotGroupRowColumns = [];
    orderedColumns.forEach(f => {
      const g = groupNameOf(f);
      const last = this.lotGroupColumns[this.lotGroupColumns.length - 1];
      if (g && last && last.name === g) {
        last.span++;
      } else {
        this.lotGroupColumns.push({ name: g, span: 1 });
        this.lotGroupRowColumns.push('lot_group_' + (this.lotGroupColumns.length - 1));
      }
    });
  }
}
